import { environment } from '@environment';

export const assistanceApi = {
  assistance_search: `${environment.api.services}/api/travel-proxy-ms/assistance/search`,
  assistance_book: `${environment.api.services}/api/travel-proxy-ms/assistance/book`,
  assistance_cancellation: `${environment.api.services}/api/travel-cancellations/cancellation-assistance`,
  assistance_convert_pdf: `${environment.urlPath}/download-pdf`
};
